import { useAppSelector } from "src/store/hooks";
import MarkdownRenderer from "./MarkdownRenderer";

const DisabledScreen = ({ studyName }: { studyName: string | undefined }) => {
    const config = useAppSelector(state => state.globalState.config);

    return (
        <div className="app-disabled-message">
            {config?.deactivatedContent && (
                <MarkdownRenderer content={config.deactivatedContent} />
            )}
        </div>
    );
};

export default DisabledScreen;